const {Component} = require("react");
const PropTypes = require("prop-types");

class Option extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string.isRequired,
			value: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			value: null
		};
	}

	render() {
		return (
			<option value={this.props.value}>{this.props.title}</option>
		);
	}

}

class Filter extends Component {

	get options() {
		return [];
	}

	get placeholder() {
		return null;
	}

	get defaultValue() {
		return "";
	}

	constructor(props) {
		super(props);
		this.state = {
			options: this.options,
			value: this.defaultValue
		};
	}

	get value() {
		return this.selectElement ?
			this.selectElement.value :
			this.state.value;
	}

	onChange() {
	}

	renderOptions() {
		let options = this.state.options.map(option => {
			return (
				<Option key={option.value} {...option}/>
			);
		});

		if (this.placeholder) {
			options.unshift(
				<Option key={"$placeholder"} title={this.placeholder}/>
			);
		}

		return options;
	}

	render() {
		return (
			<select ref={(el) => this.selectElement = el} defaultValue={this.state.value}
							onChange={this.onChange.bind(this)}>{this.renderOptions()}</select>
		);
	}

}

module.exports = Filter;
